module.exports = __webpack_public_path__ + "static/default-header-structure@2x-4368077c64f44a4339e4a68d726a9fe6.jpg";